import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/advertising-actions";

const advertisingReducer = (state = INITIAL_STATE.advertising, action) => {
  switch (action.type) {
    case TYPES.SET_ADVERTISING: {
      return action.advertising;
    }

    default:
      return state;
  }
};

export default advertisingReducer;
